import { TelegramAuthClient } from "@bridge-applications/tg-auth";
import type { z } from "zod";
import type { ZodType } from "zod";
import { API_BASE } from "../../state/config";

async function authenticatedFetch(
    path: string,
    init: RequestInit = {},
): Promise<Response> {
    const { accessToken } = await TelegramAuthClient.getAccessTokenSilently();
    const headers = new Headers(init.headers);
    headers.set("Authorization", `Bearer ${accessToken}`);
    if (init.body !== undefined && !headers.has("Content-Type")) {
        headers.set("Content-Type", "application/json");
    }

    return fetch(`${API_BASE}${path}`, {
        ...init,
        headers,
        credentials: "include",
    });
}

/** Authenticated metadata reads do not load a gameplay snapshot. */
export async function authenticatedApiHeaders(
    path: string,
    signal?: AbortSignal,
): Promise<Headers> {
    const response = await authenticatedFetch(path, {
        method: "HEAD",
        cache: "no-store",
        signal,
    });
    if (!response.ok) {
        throw new Error(`Metadata request failed with HTTP ${response.status}`);
    }
    return response.headers;
}

export async function authenticatedApiCall<TSchema extends ZodType>(
    path: string,
    schema: TSchema,
    init: RequestInit = {},
): Promise<{ body: z.output<TSchema>; httpStatus: number }> {
    const response = await authenticatedFetch(path, init);
    const raw: unknown = await response.json();
    return {
        body: schema.parse(raw),
        httpStatus: response.status,
    };
}
